/* eslint-disable no-shadow */
import useOverlay, {OverlayState} from "@/hooks/common/useOverlay";
import {useTaggingClick, TaggingClickName} from "@/hooks/common/useTagging";
import ErrorBoundary from "@COMPONENTS/common/error/ErrorBoundary";
import MailShare from "@COMPONENTS/common/modal/mail/Desktop";
import * as PcSharePub from "@COMPONENTS/style/common/share";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {TextButton} from "@FRAMEWORK/ui/desktop/button";
import {TextInput} from "@FRAMEWORK/ui/desktop/input";
import {PopupContainer} from "@FRAMEWORK/ui/desktop/popup";
import {eventDetailAsync} from "@QUERIES/prdt/event/useEventDetail";
import {goodsRecentEventAsync} from "@QUERIES/prdt/goods/useGoodsRecentEvent";
import {useRouter} from "next/router";
import {useEffect, useState} from "react";
import Share from "./Share";

interface ShareParameters {
	baseUrl?: string;
	parameter: string;
}

const {ShareWrap, SnsBtnList, SnsBtnItem, SnsBtnLink, LinkInputBlock} = PcSharePub;

const DesktopComponent = (props: ShareParameters & OverlayState) => {
	const {baseUrl = `${publicRuntimeConfig.ENV_PRODUCT_URL}${location.pathname}`, parameter, ...overlayProps} = props;
	const share = new Share(baseUrl, parameter);
	const [open] = useOverlay();

	useEffect(() => {
		Kakao && !Kakao.isInitialized() && Kakao.init(publicRuntimeConfig.ENV_KAKAO_APP_KEY);
		return () => Kakao.cleanup();
	}, []);

	// 아래는 Braze 관련 로직
	const path = location.pathname;
	const [detailPackage, setDetailPackage] = useState(null);
	const router = useRouter();
	const query = router.query;
	const evCd = query?.evCd as string;
	const goodsCd = query?.goodsCd as string;

	useEffect(() => {
		if (path.includes("detailPackage") && evCd) {
			eventDetailAsync(evCd)
				.then(fetched => {
					const body = fetched.data?.body;
					if (body) {
						setDetailPackage(body);
					}
				})
				.catch(e => {
					console.error(e);
				});
		}

		if (path.includes("detailPackage") && goodsCd) {
			goodsRecentEventAsync(goodsCd)
				.then(fetched => {
					const fetchedEvCd = fetched.data?.body?.evCd;
					eventDetailAsync(fetchedEvCd)
						.then(detailFetched => {
							const body = detailFetched.data?.body;
							if (body) {
								setDetailPackage(body);
							}
						})
						.catch(e => {
							console.error(e);
						});
				})
				.catch(e => console.error(e));
		}
	}, []);

	// tagging
	const {taggingName, taggingData}: {taggingName: TaggingClickName; taggingData: any} = path.includes("detailPackage")
		? {taggingName: "pkg_share_dtl", taggingData: detailPackage}
		: {taggingName: "pkg_share_goodsCd", taggingData: {parameter}};
	const {taggingClick} = useTaggingClick(taggingName, taggingData);

	return (
		<PopupContainer {...overlayProps} title="공유하기" size="small">
			<ShareWrap>
				<SnsBtnList>
					<SnsBtnItem>
						<SnsBtnLink
							sns="facebook"
							href="#"
							onClick={e => {
								e.preventDefault();
								share.facebook();
								taggingClick({shareCh: "페이스북"});
							}}
						>
							<span>페이스북</span>
						</SnsBtnLink>
					</SnsBtnItem>
					{/* <SnsBtnItem>
						<SnsBtnLink
							sns="kakaoStory"
							href="#"
							onClick={e => {
								e.preventDefault();
								share.kakaostory();
							}}
							data-braze-trigger="event"
							data-braze-custom-name={brazeName}
							data-braze-custom-value={getBrazeCustomValue("카카오스토리")}
						>
							<span>카카오 스토리</span>
						</SnsBtnLink>
					</SnsBtnItem> */}
					<SnsBtnItem>
						<SnsBtnLink
							sns="naver"
							href="#"
							onClick={e => {
								e.preventDefault();
								share.naver();
								taggingClick({shareCh: "네이버"});
							}}
						>
							<span>네이버</span>
						</SnsBtnLink>
					</SnsBtnItem>
					<SnsBtnItem>
						<SnsBtnLink
							sns="kakaoTalk"
							href="#"
							onClick={e => {
								e.preventDefault();
								share.kakaotalk();
								taggingClick({shareCh: "카카오톡"});
							}}
						>
							<span>카카오톡</span>
						</SnsBtnLink>
					</SnsBtnItem>
					<SnsBtnItem>
						<SnsBtnLink
							sns="email"
							href="#"
							onClick={async e => {
								e.preventDefault();
								taggingClick({shareCh: "이메일"});
								if (router.asPath.indexOf("localList") > -1) {
									open(overlay => <MailShare dspGubun="G" goodsCd={share.search.goodsCd} {...overlay} />);
								} else {
									let availEvCd = "";
									if (!evCd) {
										const avail = await goodsRecentEventAsync(goodsCd);
										availEvCd = avail.data.body.evCd;
									}
									open(overlay => <MailShare evCd={availEvCd || evCd} dspGubun="P" {...overlay} />);
								}
							}}
						>
							<span>이메일</span>
						</SnsBtnLink>
					</SnsBtnItem>
				</SnsBtnList>
				<LinkInputBlock>
					<TextInput value={share.url} readOnly />
					<TextButton
						text="링크복사"
						size="default"
						types="basic"
						onClick={() => {
							share.writeText();
							taggingClick({shareCh: "링크복사"});
						}}
					/>
				</LinkInputBlock>
			</ShareWrap>
		</PopupContainer>
	);
};

const Desktop = (props: ShareParameters & OverlayState) => (
	<ErrorBoundary logMsg="Modal Share Error">
		<DesktopComponent {...props} />
	</ErrorBoundary>
);

export default Desktop;
